var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompetitionTitle = exports.MatchScore = exports.TeamName = exports.LiveMinute = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/MatchComponents.js";

var parseScore = function parseScore(score) {
  return parseInt(score || 0);
};

var LiveMinute = function LiveMinute(_ref) {
  var minute = _ref.minute,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["minute"]);
  return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    py: 1,
    px: 2,
    bg: "highlight.main",
    color: "font.enclosed"
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }), minute || 'LIVE');
};

exports.LiveMinute = LiveMinute;

var TeamName = function TeamName(_ref2) {
  var children = _ref2.children,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["children"]);
  return _react.default.createElement(_Basic.Text, (0, _extends2.default)({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 52
    }
  }), children);
};

exports.TeamName = TeamName;
TeamName.defaultProps = {
  numberOfLines: 1,
  size: 'medium',
  p: 2,
  grow: true
};

var MatchScore = function MatchScore(_ref3) {
  var homeScore = _ref3.homeScore,
      awayScore = _ref3.awayScore,
      homePenaltyScore = _ref3.homePenaltyScore,
      awayPenaltyScore = _ref3.awayPenaltyScore,
      period = _ref3.period,
      scheduledStartTime = _ref3.scheduledStartTime,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["homeScore", "awayScore", "homePenaltyScore", "awayPenaltyScore", "period", "scheduledStartTime"]);

  if (period !== 'PRE_MATCH') {
    return _react.default.createElement(_Basic.Text, (0, _extends2.default)({}, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 13
      }
    }), homeScore !== undefined ? parseScore(homeScore) + parseScore(homePenaltyScore) : '-', ' : ', awayScore !== undefined ? parseScore(awayScore) + parseScore(awayPenaltyScore) : '-');
  }

  return scheduledStartTime ? _react.default.createElement(_Basic.Text, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 33
    }
  }, (0, _moment.default)(scheduledStartTime).format('HH:mm')) : null;
};

exports.MatchScore = MatchScore;
MatchScore.defaultProps = {
  size: 'medium',
  bold: true
};

var CompetitionTitle = function CompetitionTitle(_ref4) {
  var match = _ref4.match,
      titleSuffix = _ref4.titleSuffix;

  if (match.roundType && !match.groupName) {
    var roundNumber = (match.roundType === 'ROUND' || match.roundType === 'QUALIFIER_ROUND' || match.roundType === 'QUALIFYING') && (match.roundNumber || match.matchDay) ? (match.roundNumber || match.matchDay) + ". " : '';
    return _react.default.createElement(_Basic.Text, {
      py: 2,
      center: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 13
      }
    }, match.competition.name + ", " + roundNumber + (0, _i18n.default)("general.gameplan_entries." + match.roundType) + (titleSuffix || ''));
  }

  if (match.matchDay) {
    return _react.default.createElement(_Basic.Text, {
      py: 2,
      center: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 13
      }
    }, match.competition.name + ", " + match.matchDay + ". " + (0, _i18n.default)('match_day') + (titleSuffix || ''));
  }

  return _react.default.createElement(_Basic.Text, {
    py: 2,
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 12
    }
  }, "" + match.competition.name + (titleSuffix || ''));
};

exports.CompetitionTitle = CompetitionTitle;